// Quick view dialogs: photo thumbnails, option pills (price, stock, variant id) and quantity steps.
(function () {
  if (window.__fwpQuickView) return;
  window.__fwpQuickView = true;

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    var thumb = target.closest('[data-qv-thumb]');
    if (thumb) {
      var root = thumb.closest('[data-quick-view]');
      var track = root && root.querySelector('[data-qv-track]');
      var index = Number(thumb.getAttribute('data-qv-thumb')) || 0;
      if (track) track.scrollTo({ left: track.clientWidth * index, behavior: 'smooth' });
      root.querySelectorAll('[data-qv-thumb]').forEach(function (button) {
        button.setAttribute('aria-current', String(button === thumb));
      });
      return;
    }

    var step = target.closest('[data-qv-step]');
    if (step) {
      var input = step.closest('[data-qv-qty]').querySelector('input');
      var next = (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-qv-step'));
      input.value = String(Math.max(1, next));
    }
  });

  document.addEventListener('change', function (event) {
    var radio = event.target instanceof Element ? event.target.closest('[data-qv-variant]') : null;
    if (!radio) return;
    var root = radio.closest('[data-quick-view]');
    var id = radio.value;
    var available = radio.getAttribute('data-available') === 'true';
    var idInput = root.querySelector('[data-qv-variant-id]');
    if (idInput) idInput.value = id;
    root.querySelectorAll('[data-qv-price-for]').forEach(function (el) {
      el.hidden = el.getAttribute('data-qv-price-for') !== id;
    });
    var inStock = root.querySelector('[data-qv-stock="in"]');
    var outStock = root.querySelector('[data-qv-stock="out"]');
    if (inStock) inStock.hidden = !available;
    if (outStock) outStock.hidden = available;
    var add = root.querySelector('[data-qv-add]');
    if (add) {
      add.disabled = !available;
      var addLabel = add.querySelector('[data-qv-add-label]');
      var soldLabel = add.querySelector('[data-qv-sold-label]');
      if (addLabel) addLabel.hidden = !available;
      if (soldLabel) soldLabel.hidden = available;
    }
  });
})();
